function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.3 2a6.59 6.59 0 00-4.734 2.001l-.575.588-.574-.588a6.589 6.589 0 00-4.732-2 6.593 6.593 0 00-4.734 2C-.65 6.67-.65 11.034 1.952 13.702l8.608 8.822a1.99 1.99 0 001.431.604c.52 0 1.04-.2 1.432-.604l8.608-8.822c2.603-2.668 2.603-7.033 0-9.7A6.587 6.587 0 0017.3 2M6.685 4a4.58 4.58 0 013.301 1.397l.575.59 1.43 1.466 1.432-1.467.574-.589A4.586 4.586 0 0117.3 4 4.58 4.58 0 0120.6 5.398c1.858 1.904 1.858 5.003 0 6.907l-8.609 8.823-8.607-8.823c-1.858-1.904-1.858-5.003 0-6.907A4.583 4.583 0 016.684 4"
});

var SvgIconHeart = function SvgIconHeart(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconHeart;